import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { EmployeeService } from './core/services/employee.service';
import { Router, NavigationEnd } from '@angular/router';
import { EmployeeCacheService } from './core/services/employee-cache.service';
import { EmployeePermissionType } from './shared/models/employee/employee-permissions-type.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  public collapsed: boolean = false;
  public showHeader: boolean = true;
  private employeeLoaded: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private employeeService: EmployeeService,
    private router: Router,
    private employeeCacheService: EmployeeCacheService,
  ) { }

  get isSuperAdmin() {
    return this.employeeCacheService.checkPermissions([EmployeePermissionType.SuperAdmin]);
  }

  public ngOnInit() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    if (location.pathname.includes('embed'))
      this.showHeader = false;
  }

  public ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  private setLoginDisplay() {
    const accounts = this.authService.instance.getAllAccounts();

    if (accounts.length <= 0) {
      return;
    }

    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount) {
      activeAccount = accounts[0];
      this.authService.instance.setActiveAccount(activeAccount);
    }

    if (this.employeeLoaded) {
      return;
    }
    this.employeeLoaded = true;

    this.employeeService
      .getEmployee(activeAccount.username)
      .subscribe({
        next: (employee) => this.employeeCacheService.set(employee[0]),
        error: (err) => {
          this.employeeCacheService.set();
          console.log(err);
        }
      });
  }
}
